import React, { Component } from "react";
import Image from "react-bootstrap/Image";

class TransitionImage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <>
        <Image src={this.props.img_url} fluid />
      </>
    );
  }
}

export default TransitionImage;
